import React, { useState, useEffect } from "react";
import { Drawer, IconButton, List } from "@material-ui/core";
import {
  Home as HomeIcon,
  Add as AddIcon,
  Menu as Menu,
  Settings as Settings,
  FormatListBulleted as FormatListBulleted,
  Mail as Mail,
  VerifiedUser as VerifiedUser,
  Person as StudentiIcon,
  Timer as RitardoIcon,
  DateRange as DateRange,
  Business as Business,
  Person as Person,
  Room as Room,
  CalendarToday as CalendarToday,
  ArrowBack as ArrowBackIcon,
  Delete as Delete,
  School as School,
  BusinessCenter as BusinessCenter,
  Euro as Euro,
  PhoneAndroid as Phone,
  CompareArrows as IntermediariesIcon,
  AccountBalance as AccountBalance,
  HelpOutline,
} from "@material-ui/icons";
import { useTheme } from "@material-ui/styles";
import { withRouter, useParams } from "react-router-dom";
import classNames from "classnames";
import Cookies from 'universal-cookie';

// styles
import useStyles from "./styles";

// components
import SidebarLink from "./components/SidebarLink/SidebarLink";
import Dot from "./components/Dot";

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../context/LayoutContext";
import Tickets from "../../pages/mainAdmin/Tickets";


function getIconFromType(type){
  return <HomeIcon />;
}



function Sidebar({ location, ...props }) {
  var classes = useStyles();
  var theme = useTheme();

  //var props = useParams();

  // global
  var { isSidebarOpened } = useLayoutState();
  var layoutDispatch = useLayoutDispatch();

  // local
  var [isPermanent, setPermanent] = useState(true);

  useEffect(function() {
    window.addEventListener("resize", handleWindowWidthChange);
    handleWindowWidthChange();
    return function cleanup() {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  });

  //let menuItems = JSON.parse(props);

  let jsonItems = [];
  try {
    jsonItems = props.menuItems;
  }
  catch (error){}

  let structure = [
    { id: 1, label: "Clienti", link: "/admin/clients", icon: <CalendarToday /> },
    { id: 2, label: "Assistenza", link: "/admin/tickets", icon: <HelpOutline /> },
    { id: 8, label: "Impostazioni", link: "/admin/settings", icon: <Settings /> },
  ];

  return (
    <Drawer
      variant={isPermanent ? "permanent" : "temporary"}
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: isSidebarOpened,
        [classes.drawerClose]: !isSidebarOpened,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: isSidebarOpened,
          [classes.drawerClose]: !isSidebarOpened,
        }),
      }}
      open={isSidebarOpened}
    style={{position: 'sticky'}}

    >
      <div className={classes.toolbar} />
      <div className={classes.mobileBackButton}>
        <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
          <ArrowBackIcon
            classes={{
              root: classNames(classes.headerIcon, classes.headerIconCollapse),
            }}
          />
        </IconButton>
      </div>
      <List className={classes.sidebarList} >

        {structure.map(link => (
          <SidebarLink
            key={link.id}
            location={location}
            isSidebarOpened={isSidebarOpened}
            {...link}
          />
        ))}
      </List>
    </Drawer>
  );

  // ##################################################################
  function handleWindowWidthChange() {
    var windowWidth = window.innerWidth;
    var breakpointWidth = theme.breakpoints.values.md;
    var isSmallScreen = windowWidth < breakpointWidth;

    if (isSmallScreen && isPermanent) {
      setPermanent(false);
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
    }
  }
}

export default withRouter(Sidebar);
